import * as React from "react";
import {
  DefaultLinkModel,
  DefaultLinkWidget,
  DiagramEngine,
  AbstractLinkFactory,
  DefaultPortModel,
  PortModel,
  LinkModel
} from "storm-react-diagrams";
import { CustomLinkWidget } from "designer/widgets/CustomLinkWidget";

export class CustomLinkModel extends DefaultLinkModel {
  constructor() {
    super("custom");
  }
  markers: any;
  setMarkers(startMarker: boolean, endMarker: boolean) {
    this.markers = { startMarker, endMarker };
  }
}

export class CustomLinkFactory extends AbstractLinkFactory<CustomLinkModel> {
  constructor() {
    super("custom");
  }

  generateReactWidget(diagramEngine: DiagramEngine, link: CustomLinkModel) {
    return <CustomLinkWidget link={link} diagramEngine={diagramEngine} />;
  }

  getNewInstance(initialConfig?: any) {
    return new CustomLinkModel();
  }

  generateLinkSegmentOld(
    model: CustomLinkModel,
    widget: DefaultLinkWidget,
    selected: boolean,
    path: string
  ) {
    return (
      <path
        className={selected ? widget.bem("--path-selected") : ""}
        strokeWidth={model.width}
        stroke={model.color}
        d={path}
      />
    );
  }

  generateLinkSegment(
    model: CustomLinkModel,
    widget: DefaultLinkWidget,
    selected: boolean,
    path: string,
    startMarkerId: string = "-",
    endMarkerId: string = "-"
  ) {
    return (
      <path
        className={selected ? widget.bem("--path-selected") : ""}
        strokeWidth={model.width}
        stroke={model.color}
        d={path}
        markerStart={"url(#" + startMarkerId + ")"}
        markerEnd={"url(#" + endMarkerId + ")"}
      />
    );
  }
}

export class CustomPortModel extends DefaultPortModel {
  link(port: PortModel): LinkModel {
    let link = this.createLinkModel();
    link.setSourcePort(this);
    link.setTargetPort(port);
    link.setMarkers(false, true);

    return link;
  }
  createLinkModel(): CustomLinkModel {
    return new CustomLinkModel();
  }
}



// WEBPACK FOOTER //
// ./src/designer/widgets/CustomLinkFactory.tsx